import Vue from '@vue/compat';
import verifyPageOptions from './verify-page.js';

function mountPage(selector, options) {
  if (!document.querySelector(selector)) return null;
  return new Vue({ el: selector, ...options });
}

window.qkVerifyPage = mountPage('.verify-body', verifyPageOptions);

export { verifyPageOptions };
